import React from "react";
import Grid from "@material-ui/core/Grid";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import {Typography} from "@material-ui/core";


export default function OptionChainStrategyCheckboxes({
                                                          otm1Enabled,
                                                          setOtm1Enabled,
                                                          hugCurrentPriceEnabled,
                                                          setHugCurrentPriceEnabled,
                                                          itm1Enabled,
                                                          setItm1Enabled,
                                                          dispatchOtm1,
                                                          dispatchItm1
                                                      }) {
    const handleChange = (ev) => {
        switch (ev.target.value) {
            case "OTM1":
                setOtm1Enabled(true);
                setHugCurrentPriceEnabled(false);
                setItm1Enabled(false);
                dispatchOtm1({});
                break;
            case "ITM1":
                console.log("setting itm1");
                setItm1Enabled(true);
                setOtm1Enabled(false);
                setHugCurrentPriceEnabled(false);
                dispatchItm1({});
                break;
            case "hugCurrentPrice":
                setHugCurrentPriceEnabled(true);
                setOtm1Enabled(false);
                setItm1Enabled(false);
                break;
        }
    };

    return (
        <Grid container>
            <RadioGroup
                row
                aria-label="optionStrategy"
                name="optionStrategy"
                //  value={top.instrument}
                onChange={handleChange}
            >
                <Grid item xs={5}>
                    <FormControlLabel
                        value="hugCurrentPrice"
                        checked={hugCurrentPriceEnabled}
                        control={<StyledRadio/>}
                        label={
                            <Typography style={{fontSize: 10}}>tightestSpread</Typography>
                        }
                        labelPlacement={"top"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel
                        value="OTM1"
                        checked={otm1Enabled}
                        control={<StyledRadio/>}
                        label={
                            <Typography style={{fontSize: 10}}>otm1</Typography>
                        }
                        labelPlacement={"top"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel
                        value="ITM1"
                        checked={itm1Enabled}
                        control={<StyledRadio/>}
                        label={
                            <Typography style={{fontSize: 10}}>itm1</Typography>
                        }
                        labelPlacement={"top"}
                    />
                </Grid>
            </RadioGroup>
        </Grid>
    )
}